import React from 'react';
import { Field } from 'formik';

import styles from './firmReferencesFormStyles';

import InputField from 'buyside/components/presentation/Form/Field/InputField/inputField';
import AddRemoveForm from 'buyside/components/presentation/Form/AddRemoveForm/addRemoveForm';

// NOTE: make sure to update the appropriate schema in util/fundProfileShowPageValidationSchemata

const FirmReferencesForm = () => {
  const renderFirmReference = firmReferencePath => (
    <div>
      <div className={styles.firmReferenceRow}>
        <div className={styles.firmReferenceColumn}>
          <Field component={InputField} name={firmReferencePath + '.name'} label="Name" />
        </div>
        <div className={styles.firmReferenceColumn}>
          <Field component={InputField} name={firmReferencePath + '.employer'} label="Employer" />
        </div>
      </div>
      <div className={styles.firmReferenceRow}>
        <div className={styles.firmReferenceColumn}>
          <Field component={InputField} name={firmReferencePath + '.title'} label="Title" />
        </div>
        <div className={styles.firmReferenceColumn}>
          <Field component={InputField} name={firmReferencePath + '.contactEmail'} label="Email" />
        </div>
      </div>
      <div className={styles.firmReferenceRelationship}>
        <Field
          component={InputField}
          name={firmReferencePath + '.relationshipToFund'}
          type="textarea"
          label="Relationship to Fund"
        />
      </div>
    </div>
  );

  return (
    <AddRemoveForm
      title="References"
      attr="fundProfile.firmReferences"
      renderItem={renderFirmReference}
      itemName="Reference"
      blankItem={{
        name: '',
        employer: '',
        title: '',
        contactEmail: '',
        relationshipToFund: ''
      }}
    />
  );
};

export default FirmReferencesForm;
